var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconVideo32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.888a.5.5 0 01.76-.428l8.001 4.854a.5.5 0 01-.018.865l-8.002 4.412a.5.5 0 01-.741-.438v-9.265z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 26A2.75 2.75 0 009 28.75h14A2.75 2.75 0 0025.75 26V9.998a.75.75 0 00-.22-.53l-6.002-5.999a.75.75 0 00-.53-.219H9A2.75 2.75 0 006.25 6v20zM9 27.25c-.69 0-1.25-.56-1.25-1.25V6c0-.69.56-1.25 1.25-1.25h9V9a2 2 0 002 2h4.25v15c0 .69-.56 1.25-1.25 1.25H9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo32);
export default __webpack_public_path__ + "static/media/icon-video-32.c92503e9.svg";
export { ForwardRef as ReactComponent };